import { render, staticRenderFns } from "./CopyableElement.vue?vue&type=template&id=64c24137&scoped=true&"
import script from "./CopyableElement.vue?vue&type=script&lang=js&"
export * from "./CopyableElement.vue?vue&type=script&lang=js&"
import style0 from "./CopyableElement.vue?vue&type=style&index=0&id=64c24137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c24137",
  null
  
)

export default component.exports